import { PreloadedQuery } from 'react-relay';

import { createRelayResource } from '@townsquare/relay-utils';
import { RouteResource } from '@townsquare/router/routing-types';

import NoWorkspacePersonalSettingsViewQuery, {
	NoWorkspacePersonalSettingsViewQuery as NoWorkspacePersonalSettingsViewQueryType,
} from '../components/__generated__/NoWorkspacePersonalSettingsViewQuery.graphql';

export const noWorkspacePersonalSettingsPageResource: RouteResource<
	PreloadedQuery<NoWorkspacePersonalSettingsViewQueryType, Record<string, unknown>>
> = createRelayResource<NoWorkspacePersonalSettingsViewQueryType>({
	getQuery: () => {
		return {
			query: NoWorkspacePersonalSettingsViewQuery,
		};
	},
});
